import { useEffect, useState } from 'react'
import Head from 'next/head'
import Script from 'next/script'
import Link from 'next/link'
import Image from 'next/image'
import { motion } from 'framer-motion'
import { s3Static } from '../../../utils/constants'
import { getArticleDateTime } from '../../../utils/article-date-time'
import { BlogsList } from '../../../components/blogs/BlogList'
import { blogsMaster } from '../../../utils/sg-blogs-data'
import { getRequestJSON } from '../../../api/index/location-api'
import { useRouter } from 'next/router'
import { getWpNewPostsByCategory, getWpPostsByCategory } from '../../../lib/service'
import { getWpHealthFitness, getWpNewHealthFitness, setWpHealthFitness, setWpNewHealthFitness } from '../../../service/wp-blogs-store'
import { PersonalTrainerHead } from '@/index/service-category/personal-trainer/PersonalTrainerHead'
import { PersonalTrainerBooking } from '@/index/service-category/personal-trainer/PersonalTrainerBooking'
import { openModal } from 'service/modal-service'
import { TrainerCustomerReviews } from '@/index/service-category/personal-trainer/TrainerCustomerReviews'
import { ptSingaporeFaqs } from 'utils/faq'
import { RequestProvider } from 'context/RequestContext'
import { PersonalTrainerWhyUs } from '@/index/service-category/personal-trainer/PersonalTrainerWhyUs'
import { getTestimonials } from 'api/user/profile-api'
import { getPtTestimonials, setPtTestimonials } from 'service/testimonial-store'
import { DarkFaq } from '@/index/service-category/personal-trainer/DarkFaq'
import { FaCheckCircle } from 'react-icons/fa'
import TrustedPartners from '@/index/service-category/personal-trainer/TrustedPartners'
import { localBusinessNode, buildServiceNode } from 'utils/local-business-schema'

export async function getStaticProps() {
    const countryName = "Singapore"
    const { modifiedDate, month, year } = getArticleDateTime();
    const fitnessBlogs = blogsMaster['health-fitness'].blogArray;
    const wpPosts = getWpHealthFitness().length > 0 ?  getWpHealthFitness() : await getWpPostsByCategory(6, "health-fitness");
    setWpHealthFitness(wpPosts)
    const wpNewPosts = getWpNewHealthFitness().length > 0 ?  getWpNewHealthFitness() : await getWpNewPostsByCategory(6, "health-fitness");
    setWpNewHealthFitness(wpNewPosts)

    const allRequestCategorySettings = await getRequestJSON("Singapore")
    const testimonials = getPtTestimonials().length > 0 ? getPtTestimonials() : await getTestimonials("Fitness Trainer", 0, 6)
    setPtTestimonials(testimonials)
    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Fitness Trainer")

  return {
      props: {
        requestCategorySettings,
        modifiedDate,
        month,
        year,
        fitnessBlogs,
        wpPosts,
        wpNewPosts,
        testimonials
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}

export default function Home(props) {
    const router = useRouter()
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const fitnessBlogs = props.fitnessBlogs
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts
    const requestCategorySettings = props.requestCategorySettings;
    const testimonials = props.testimonials
        
    const [ requestForm, setRequestForm ] = useState(false)
    
    const requestType = "Fitness Trainer"
    const [isQuickBook, setIsQuickBook] = useState(false)
    const [isCustomBook, setIsCustomBook] = useState(false)

    const openRequestForm = () => {
        window.scrollTo({ top: 0 });
        openModal(setRequestForm)
    }

    useEffect(() => {
        if(router.query.requestForm === "true"){
            setRequestForm(true)
            openModal(setRequestForm)
        }
    }, [router])

  return (
    <>
      <Head>
        <title>Personal Trainer for Weight Loss in Singapore</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="Hire top-rated weight loss trainers in Singapore. Personalized diets, HIIT workouts & progress tracking with certified personal trainers for sustainable fat loss. Start your journey today!"/>
        <meta name="keywords" content="weight loss trainer, personal trainer for weight loss, certified personal trainer Singapore, fat loss expert, belly fat reduction, sustainable weight loss, HIIT training Singapore"/>
        <meta name="robots" content="index, follow" />
        <meta name="author" content="StringsSG - Personal Training"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/personal-trainer/weight-loss-trainer" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Personal Trainer for Weight Loss in Singapore`}/>
        <meta property="og:description" content="Hire top-rated weight loss trainers in Singapore. Personalized diets, HIIT workouts & progress tracking with certified personal trainers for sustainable fat loss. Start your journey today!" />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-26T07:30:46+00:00" />
        <meta property="article:modified_time" content={`${modifiedDate}`} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/diet.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/diet.jpg" />
        <meta name="twitter:site" content="@stringssg"/>
        <meta name="twitter:url" content="https://www.stringssg.com/sg/personal-trainer/weight-loss-trainer"/>
        <meta name="twitter:title" content={`Personal Trainer for Weight Loss in Singapore`}/>
        <meta name="twitter:description" content="Hire top-rated weight loss trainers in Singapore. Personalized diets, HIIT workouts & progress tracking with certified personal trainers for sustainable fat loss. Start your journey today!"/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/sg/personal-trainer/weight-loss-trainer" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/personal-trainer/weight-loss-trainer"},"headline":"Fitness Trainer For Weight Loss | Get Rid Of Belly Fat","description":"If you are looking to get rid of the extra fat around your belly, you might need a trainer who has proven expertise and certifications to help with weight loss.","image":["https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/diet.jpg"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"2025-01-26T07:30:46+00:00","dateModified":"${modifiedDate}"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"personal-trainer","item":"https://www.stringssg.com/sg/personal-trainer"},{"@type":"ListItem","position":2,"name":"weight-loss"}]},${JSON.stringify(localBusinessNode)},${JSON.stringify(buildServiceNode({ pageUrl: "https://www.stringssg.com/sg/personal-trainer/weight-loss-trainer", name: "Weight Loss Personal Trainer Singapore", serviceType: "Personal Training", priceRange: "S$84.00 - S$110.00", image: "https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/lady-personal-trainer-helping-man.jpg" }))}]}`
          }}
        />
        </Head>
        <div>
            <RequestProvider>
                <PersonalTrainerHead 
                    heroImage={s3Static + "personal-trainer/personal-trainer-plan.png"}
                    title="Personal Trainer for Weight Loss in Singapore"
                    heading="Personal Trainer for Weight Loss in Singapore"
                    heroCopy="Fat-loss coaching from $84/session, combining structured training with practical nutrition guidance. Most clients see change in 1-2 months."
                    setIsQuickBook={setIsQuickBook}
                    openRequestForm={openRequestForm}
                    requestForm={requestForm}
                    setRequestForm={setRequestForm}
                    isQuickBook={isQuickBook}
                    isCustomBook={isCustomBook}
                    requestType={requestType}
                    requestCategorySettings={requestCategorySettings}
                />            
                <section className="mx-auto py-6 px-2 bg-slate-900 relative">
                    {/* Mesh gradient */}
                    <div className="absolute top-0 right-0 w-96 h-96 bg-orange-500/15 rounded-full blur-3xl" />
                    <div className="absolute bottom-0 left-0 w-80 h-80 bg-amber-400/10 rounded-full blur-3xl" />
                    {/* <h2 className='text-2xl md:text-4xl text-center text-white font-extrabold tracking-tight py-5'>
                        <strong>Personal Trainer for Weight Loss in Singapore</strong>
                    </h2> */}
                    <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center py-6 relative">                    
                        <div className="text-white/60 space-y-5 leading-8 text-lg">
                            <p className="text-white/60 leading-7">
                                Struggling with stubborn belly fat or looking to shed kilos healthily? 
                                Hire a <strong>certified personal trainer for weight loss</strong> who can guide you with structured fitness routines, meal plans, 
                                and personalized support—whether at home or condo gym. 
                                With hundreds of successful clients across Singapore and our in-house certified trainers, 
                                we&apos;re here to help you achieve sustainable weight loss.
                            </p>
                            <p className="text-white/60 mb-8 leading-relaxed">
                                At StringsSG, weight loss training is one of the key services we offer through our dedicated team of full-time trainers and experienced 
                                fitness professionals across Singapore. We help you get started based on what works best for you:
                            </p>
                            <ul className="space-y-4">
                                <li className="font-bold text-white/90 flex items-center gap-2">
                                    <FaCheckCircle className="text-orange-400" />
                                    Your location
                                </li>
                                <li className="font-bold text-white/90 flex items-center gap-2">
                                    <FaCheckCircle className="text-orange-400" />
                                    Your fitness goals
                                </li>
                                <li className="font-bold text-white/90 flex items-center gap-2">
                                    <FaCheckCircle className="text-orange-400" />
                                    Your preferred training schedule
                                </li>
                            </ul>
                        </div>
                        {/* Image Section */}
                        <div className="relative h-62.5 lg:h-87.5">
                            {/* Floating badge - Certified */}
                            <div className="absolute top-4 right-4 z-10 bg-white/10 backdrop-blur-md rounded-2xl px-4 py-3 shadow-xl border border-white/20">
                                <div className="flex items-center gap-2">
                                    <div className="w-10 h-10 bg-linear-to-br from-green-400 to-emerald-500 rounded-xl flex items-center justify-center">
                                        <FaCheckCircle className="text-white" />
                                    </div>
                                    <div>
                                        <p className="text-xs text-white/50">Certified</p>
                                        <p className="font-bold text-white/90">Trainers</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="relative w-full h-full rounded-3xl overflow-hidden shadow-2xl">
                                <Image
                                    src={s3Static + "personal-trainer/personal-trainer-png.png"}
                                    fill
                                    style={{ objectFit: 'contain', objectPosition: 'top' }}
                                    alt="Personal Trainer Singapore - StringsSG"
                                    sizes="(max-width: 768px) 100vw, 50vw"
                                />
                            </div>
                        </div>
                    </div>
                </section>                  
                {/* <TrustedPartners/> */}

                {/* ── Image Break 1 ── */}
                <section className="bg-slate-900 py-6 px-4">
                    <div className="max-w-5xl mx-auto rounded-3xl overflow-hidden border border-white/10">
                        <Image src={s3Static + "fitness1.jpg"} alt="Weight loss personal training session in Singapore" width={1200} height={600} className="w-full h-48 md:h-72 object-cover" />
                    </div>
                </section>

                <section className="px-3 md:px-4 py-10 md:py-16 bg-slate-900 relative overflow-hidden">
                        {/* Mesh gradient blobs */}
                        <div className="absolute top-0 left-1/4 w-96 h-96 bg-orange-500/15 rounded-full blur-3xl" />
                        <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-amber-400/10 rounded-full blur-3xl" />
                        <div className="absolute top-1/2 right-0 w-64 h-64 bg-rose-500/10 rounded-full blur-3xl" />
                    {/* Section Header */}
                    <div className="max-w-3xl mx-auto text-center mb-10 relative z-10">
                        <h2 className="text-2xl md:text-3xl font-extrabold text-white tracking-tight mb-4">What Our Weight Loss Training Covers</h2>
                        <p className="text-white/50 leading-relaxed">Our certified trainers combine customized workouts, nutrition planning, and consistent progress tracking to help you lose weight safely and sustainably—tailored to your body, goals, and lifestyle.</p>
                        <p className="text-white/50 leading-relaxed mt-3">
                            Weight loss coaching sits in the middle of the market on price. Compare{' '}
                            <Link href="/sg/personal-trainer/personal-trainer-rates-singapore" prefetch={false} className="text-orange-400/90 hover:text-orange-400 underline">
                                current personal trainer rates in Singapore
                            </Link>{' '}
                            to see how fat loss programmes are priced against strength, rehab and specialist coaching.
                        </p>
                    </div>
                    {/* Benefit Cards */}
                    <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-6">
                        {[
                        {
                            icon: "🏃‍♂️",
                            title: "Custom Workout Programs",
                            desc: "Your trainer designs a personalized mix of cardio, HIIT, and strength training routines based on your current fitness level, body composition, and weight loss targets.",
                        },
                        {
                            icon: "🥗",
                            title: "Diet & Nutrition Planning",
                            desc: "Receive science-backed meal plans based on your BMI, BMR, and caloric needs. Your trainer guides you on macros, meal timing, and sustainable eating habits—no crash diets.",
                        },
                        {
                            icon: "📈",
                            title: "Ongoing Progress Tracking",
                            desc: "Regular body composition checks, measurements, and performance assessments keep you accountable. Your trainer adjusts your plan to break through plateaus and maintain momentum.",
                        },
                        {
                            icon: "🏋️‍♀️",
                            title: "Strength & Metabolism Boost",
                            desc: "Build lean muscle while burning fat. Resistance training increases your resting metabolic rate, meaning you continue burning calories even after your workout ends.",
                        },
                        {
                            icon: "🏠",
                            title: "Train Anywhere You Prefer",
                            desc: "Choose your training location—home, condo gym, ActiveSG facility, or outdoor park. Flexible scheduling means your weight loss journey fits around your life, not the other way around.",
                        },
                        {
                            icon: "🔬",
                            title: "Certified Weight Loss Specialists",
                            desc: "Work with NASM, ACE, or ACSM certified trainers who specialize in fat loss, body recomposition, and metabolic conditioning. Expert guidance ensures safe, effective results.",
                        },
                        ].map((item, i) => (
                        <motion.div
                            key={i}
                            initial={{ opacity: 0, y: 50 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: i * 0.1 }}
                            className="bg-white rounded-3xl shadow-md p-6 text-center hover:shadow-xl transition transform hover:-translate-y-1"
                        >
                            <div className="text-5xl mb-4">{item.icon}</div>
                            <h3 className="font-semibold text-lg text-gray-800 mb-2">{item.title}</h3>
                            <p className="text-gray-600 leading-relaxed text-sm">{item.desc}</p>
                        </motion.div>
                        ))}
                    </div>

                    {/* FAQ / Expectations */}
                    <div className="max-w-6xl mx-auto mt-14 space-y-6">
                        <h2 className="text-2xl font-extrabold text-white text-center">
                        When will I see results with a weight loss trainer?
                        </h2>
                        <p className="text-white/60 leading-7">
                        In the first 4–6 weeks, you may notice weight fluctuations due to water retention, which is completely normal. As your body adapts to the new workout routine and nutrition, consistent fat loss typically begins after week 6. A <strong>qualified personal trainer</strong> helps break plateaus and keeps your metabolism active with dynamic changes.
                        </p>
                        <p className="text-sm text-white/60 italic">
                        Tip: Track progress via inches lost, body fat %, and strength gained—not just the weighing scale.
                        </p>
                    </div>

                    {/* CTA */}
                    <div className="mt-10 text-center">
                        <Link
                        href="/sg/personal-trainer"
                        prefetch={false}
                        className="inline-block px-8 py-3 text-white font-semibold rounded-full bg-linear-to-tr from-orange-600 to-amber-400 hover:opacity-90 transition"
                        >
                        Browse Trainers for Weight Loss
                        </Link>
                    </div>
                </section>  
                <section className='bg-slate-900 relative overflow-hidden'>
                <div className="max-w-5xl mx-auto py-10 px-4">
                    <h2 className="text-2xl font-extrabold text-center text-white mb-8">Expert Tips for Sustainable Weight Loss</h2>
                    <div className="grid md:grid-cols-2 gap-6">
                        <div className="bg-linear-to-r from-blue-50 to-cyan-50 p-6 rounded-2xl border-l-4 border-blue-500">
                            <h3 className="text-lg font-semibold text-blue-800 mb-2">Nutrition First</h3>
                            <p className="text-gray-700 leading-6">Focus on a calorie deficit diet rich in proteins, veggies, and healthy fats. Avoid fad diets—sustainable changes lead to lasting results.</p>
                        </div>
                        <div className="bg-linear-to-r from-green-50 to-emerald-50 p-6 rounded-2xl border-l-4 border-green-500">
                            <h3 className="text-lg font-semibold text-green-800 mb-2">Consistent Exercise</h3>
                            <p className="text-gray-700 leading-6">Combine cardio, strength training, and HIIT. Aim for 150 minutes of moderate activity per week plus strength sessions twice weekly.</p>
                        </div>
                        <div className="bg-linear-to-r from-purple-50 to-violet-50 p-6 rounded-2xl border-l-4 border-purple-500">
                            <h3 className="text-lg font-semibold text-purple-800 mb-2">Track & Adjust</h3>
                            <p className="text-gray-700 leading-6">Monitor progress through measurements, photos, and strength gains. Adjust plans every 4 weeks to avoid plateaus.</p>
                        </div>
                        <div className="bg-linear-to-r from-orange-50 to-amber-50 p-6 rounded-2xl border-l-4 border-orange-500">
                            <h3 className="text-lg font-semibold text-orange-800 mb-2">Mindful Habits</h3>
                            <p className="text-gray-700 leading-6">Sleep 7-9 hours nightly, manage stress, and stay hydrated. Mindful eating prevents overeating and emotional eating.</p>
                        </div>
                    </div>
                </div>        
                </section> 
                {/* ── Image Break 2 ── */}
                <section className="bg-slate-900 py-6 px-4">
                    <div className="max-w-5xl mx-auto rounded-3xl overflow-hidden border border-white/10">
                        <Image src={s3Static + "fitness-trainer-mobile.jpg"} alt="Mobile fitness trainer for weight loss in Singapore" width={1200} height={600} className="w-full h-48 md:h-72 object-cover" />
                    </div>
                </section>

                <PersonalTrainerWhyUs/>
                {/* ── Image Break 3 ── */}
                <section className="bg-slate-900 py-6 px-4">
                    <div className="max-w-5xl mx-auto rounded-3xl overflow-hidden border border-white/10">
                        <Image src={s3Static + "blog/health+and+fitness/belly-body-calories-diet.jpg"} alt="Belly fat reduction and diet planning for weight loss" width={1200} height={600} className="w-full h-48 md:h-72 object-cover" />
                    </div>
                </section>

                <PersonalTrainerBooking setIsQuickBook={setIsQuickBook} openRequestForm={openRequestForm} year={year} />
                <TrainerCustomerReviews testimonials={testimonials}/>
            </RequestProvider>
            <section className="relative py-8 md:py-12 overflow-hidden bg-slate-900">
                <div className="absolute top-0 left-0 w-72 h-72 bg-orange-500/8 rounded-full blur-3xl" />
                <div className='relative z-10 max-w-5xl mx-auto px-4'>
                    <DarkFaq 
                        title="Personal Training FAQs"
                        questionsAnswers={ptSingaporeFaqs} 
                    />
                </div>
            </section>
            <BlogsList blogs={fitnessBlogs} wpPosts={wpPosts} wpNewPosts={wpNewPosts} theme="dark"/>
        </div>
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
